<template>
  <form-component class="filter-sidebar">
    <form novalidate="novalidate" @submit.prevent>
      <h2 class="mb-4">Filters</h2>
      <button class="btn back-btn" type="button" @click="onReset">
        <span>Reset</span>
        <font-awesome-icon :icon="['fas', 'undo']" class="icon alt" />
      </button>
      <div class="form-row">
        <div class="col-12 col-md-2">
          <input-select
            id="active"
            v-model="value.active"
            name="active"
            label="Active"
            :placeholder="null"
            :options="activeOptions"
          />
        </div>
        <div class="col-12 col-md-2">
          <input-select
            id="active"
            v-model="value.verified"
            name="verified"
            label="Verifed"
            :placeholder="null"
            :options="verifiedOptions"
          />
        </div>
        <div class="col-12 col-md-2">
          <input-select
            id="hasAvailability"
            v-model="value.hasAvailability"
            name="hasAvailability"
            label="Has Availability"
            :placeholder="null"
            :options="availabilityOptions"
          />
        </div>
        <div class="col-12 col-md-3">
          <input-select
            id="stateId"
            v-model="value.stateId"
            :value="value.stateId"
            label="State"
            name="stateId"
            placeholder="Show All States"
            placeholder-enabled
            :options="states"
            @input="onStateChanged"
          />
        </div>
        <div class="col-12 col-md-3">
          <input-select
            id="languages"
            v-model="value.languageId"
            name="languages"
            label="Secondary Language"
            :placeholder="languages.length > 0 ? 'Show All Secondary Languages' : 'No Secondary Languages Available' "
            placeholder-enabled
            :options="languages"
          />
        </div>
      </div>
    </form>
  </form-component>
</template>

<script>
import UserClient from '@/api/UserClient';
import CounselorClient from '@/api/CounselorClient';
import FormComponent from '@/components/FormComponent.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  components: {
    FormComponent,
    InputSelect
  },

  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      userClient: new UserClient(this.$http),
      counselorClient: new CounselorClient(this.$http),

      activeOptions: [
        { id: '', display_label: 'Show All' },
        { id: 'true', display_label: 'Show Active Only' },
        { id: 'false', display_label: 'Show Inactive Only' }
      ],
      verifiedOptions: [
        { id: '', display_label: 'Show All' },
        { id: 'true', display_label: 'Show Verified Only' },
        { id: 'false', display_label: 'Show Unverified Only' }
      ],
      availabilityOptions: [
        { id: '', display_label: 'Show All' },
        { id: 'true', display_label: 'Show Available Only' },
        { id: 'false', display_label: 'Show Unavailable Only' }
      ]
    };
  },

  asyncComputed: {
    states: {
      default: [],
      async get() {
        const response = await this.counselorClient.getAllCounselorStates();
        return response && response.states
          ? response.states
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((s) => ({ id: s.id.toString(), display_label: s.name }))
          : [];
      }
    },
    languages: {
      default: [],
      async get() {
        const response = await this.counselorClient.getAllCounselorLanguages(this.value.stateId);
        return response && response.languages
          ? response.languages
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((s) => ({ id: s.id.toString(), display_label: s.name }))
          : [];
      }
    }
  },

  watch: {
    value: {
      deep: true,
      handler(filters) {
        this.$emit('input', filters);
      }
    }
  },

  methods: {
    onReset() {
      this.$emit('reset');
    },
    onStateChanged() {
      this.value.languageId = '';
    }
  }
};
</script>
